import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import http from './plugins/axios.js'
import Calendar from 'vue-mobile-calendar'
import VueMessage from './components/message'
Vue.use(VueMessage)
Vue.use(Calendar);

Vue.config.productionTip = false
Vue.prototype.$http = http 

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
